import React from "react";
import submit from "submit-form";

const PRODUCTS = [
  {
    label: "General",
    value: "general",
  },
  {
    label: "PUSH",
    value: "push",
  },
  {
    label: "PULL",
    value: "pull",
  },
];

const ProductSelector = ({
  selected,
  hasFreeTrial,
  isActivePull,
  isActivePush,
  isAdmin,
}) => {
  const navigateToSection = (product) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        product,
        category: "",
      },
    });
  };

  const filteredProducts = PRODUCTS.filter((product) => {
    if (
      product.value === "pull" &&
      !(isActivePull || hasFreeTrial || isAdmin)
    ) {
      return false;
    }
    if (product.value === "push" && !(isActivePush || isAdmin)) {
      return false;
    }
    return true;
  });

  return (
    <div className="product-selector">
      {filteredProducts.map(({ label, value }, idx) => {
        return (
          <button
            data-button-type={selected === value ? "outline" : "secondary"}
            key={idx}
            onClick={() => navigateToSection(value)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ProductSelector;
